import React, { memo } from 'react'
import { useForm } from 'react-hook-form'
import { Autocomplete } from 'components/forms/autocomplete/DPLAutocomplete'
import ControlledTextField from 'transfix-form/components/ControlledTextInput'
import { ChangeRateData } from 'apps/marketplace/utils/helpers/useCarrier'

interface ICarrierProps {
  carrierId: number
  carrierName: string
  contractId: number
  onChange: (changes: Partial<ChangeRateData>) => void
  readOnly: boolean
}

export const Carrier = memo<ICarrierProps>(
  ({ carrierId, carrierName, contractId, onChange, readOnly }) => {
    const onCarrierChange = ({
      value,
      fullSelection: { name } = {},
    }: {
      value: number
      fullSelection: { name?: string }
    }) =>
      onChange({
        carrierId: value,
        carrierName: name || '',
      })
    const { control } = useForm()

    return (
      <div className='row'>
        {!contractId && !readOnly && (
          <div className='col-md-6' data-test='add-carrier'>
            <Autocomplete
              id='carrier'
              label='Carrier'
              required
              value={carrierName}
              placeholder='Search by Carrier Name, MC, or DOT'
              onChange={onCarrierChange}
              type='mc'
            />
          </div>
        )}
        {carrierId && carrierName && (
          <div className='col-md-12'>
            <ControlledTextField
              name='contactEmail'
              TextInputProps={{
                type: 'text',
                defaultValue: carrierName,
                label: 'Carrier',
                dataTest: 'carrier-name',
                required: true,
                disabled: true,
              }}
              control={control}
            />
          </div>
        )}
      </div>
    )
  }
)
